import axios from 'axios';
const instance = axios.create({baseURL: 'https://api.mylotspy.com/api/v1'});
export default instance;
